import React from 'react';
import classnames from 'classnames';
import { Icon, Spinner } from '@iq/react-components';

const StepIndicator = ({
  title,
  icon,
  active,
  checked,
  wizardTheme,
  onSelect,
  disabled,
  loading,
}) => {
  const activeClass = classnames({ 'step-indicator--active': active });
  const completedClass = classnames({ checked });
  const disabledClass = classnames({ 'step-indicator--disabled': disabled });

  return (
    <li className="step-indicator__item">
      <button
        type="button"
        className={`step-indicator step-indicator--${wizardTheme} ${activeClass} ${disabledClass}`}
        onClick={disabled ? undefined : onSelect}
        title={disabled ? 'Requires at least one source' : ''}
        disabled={disabled}
      >
        <div className="step-indicator__title-container">
          <div className="step-indicator__icon">
            <Icon icon={icon} />
          </div>
          <div className="step-indicator__title">{title}</div>
        </div>
        {loading ? (
          <Spinner
            size="s"
            className="spinner"
          />
        ) : (
          <div className={`step-indicator__completion ${completedClass}`}>
            <Icon
              icon="he-systemfeedbacksuccess"
              size="l"
            />
          </div>
        )}
      </button>
    </li>
  );
};

export default StepIndicator;
